
import { defineComponent, PropType } from 'vue'

interface IData {
  statusPayment: boolean | null
}
export default defineComponent({
  name: 'PaymentProcess',
  props: {
    status: {
      type: Boolean as PropType<boolean>,
      default: null
    },
    errorMessage: {
      type: String as PropType<string>,
      default: ''
    },
    show: {
      type: Boolean as PropType<boolean>,
      default: false
    }
  },

  emits: ['closeOperation', 'closePaymentWait', 'callYandexMetricGoal'],

  data (): IData {
    return {
      statusPayment: null
    }
  },
  computed: {
    statusTitle (): string {
      if (this.statusPayment) {
        this.$emit('callYandexMetricGoal', 'successPay')
        return 'Оплата прошла успешно!'
      }
      if (this.statusPayment === false) {
        return 'Оплата не прошла'
      }
      return 'Производится оплата'
    }
  },
  watch: {
    status (newValue) {
      setTimeout(() => {
        this.statusPayment = newValue
      }, 1500)

      if (newValue) {
        setTimeout(() => {
          this.$emit('closeOperation', true)
        }, 4500)
      }
    },
    show () {
      if (this.show) {
        this.$emit('closePaymentWait')
      }
    }
  },
  // mounted () {
  //   this.$emit('closePaymentWait')
  // },
  methods: {
    close (): void {
      if (this.statusPayment === false) {
        this.$emit('closeOperation', false)
      }
    }
  }
})
